<template>
  <Button variant="outline" size="lg" @click="exportContacts">
    Export
    <vue-feather type="arrow-up-right" size="20" />
  </Button>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import { Button } from '@/components/ui/button';
import type { ContactRecordType } from '@/api/entity_types/Contact';

const { contactType } = defineProps<{
  contactType: ContactRecordType;
}>();

const loadingSpinnerStore = useLoadingSpinnerStore();

const urlPath = computed<string>(() => {
  if (contactType === 'Teammate') {
    return '/api/teammates/download_csv';
  } else {
    return '/api/contacts/download_csv';
  }
});

async function exportContacts() {
  loadingSpinnerStore.showLoadingSpinner();
  const response = await fetch(urlPath.value);
  const data = await response.blob();

  let file = window.URL.createObjectURL(data);
  let a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';
  a.href = file;
  a.download = `${contactType.toLowerCase()}_export.csv`;
  a.click();
  window.URL.revokeObjectURL(file);
  loadingSpinnerStore.hideLoadingSpinner();
}
</script>
